import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../../../api/api.service';
import * as _ from 'lodash';
import store from './../../../store/store.module';
import { FETCH_LOCATIONS_REQUESTED, DELETE_LOCATION_REQUESTED, LOCATION_COMPONENT_UPDATE_DESTINATION_FILTER, PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER } from './list.action';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { UPDATE_LOCATION_REQUESTED } from '../edit/edit.actions';
import { UtilityService } from '../../../common/services/utility/utility.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
  navigationSubscription: Subscription;
  public store = store;
  selectAll = false;
  destinations: any[] = [];
  locations: any[] = [];
  public LOCATION_COMPONENT_UPDATE_DESTINATION_FILTER = LOCATION_COMPONENT_UPDATE_DESTINATION_FILTER;

  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, private router: Router) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        store.dispatch({ type: FETCH_LOCATIONS_REQUESTED, data: this.getQuery() });
        if (!_.isUndefined(this.activeRouter.snapshot.queryParams.constraints)) {
          let constraints = JSON.parse(this.activeRouter.snapshot.queryParams.constraints);
          if (!_.isUndefined(constraints.destination_id)) {
            store.dispatch({ type: PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER, data: { destination_id: constraints.destination_id } });
          } else {
            store.dispatch({ type: PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER, data: {} });
          }
        } else {
          store.dispatch({ type: PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER, data: {} });
        }
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  public getQuery(): object {
    let supportedParams = ['sort', 'constraints', 'page', 'per_page', 'search'];
    let queryParams = { page: 1 };
    if (_.keys(this.activeRouter.snapshot.queryParams).length > 0) {
      queryParams = _.assign(queryParams, this.activeRouter.snapshot.queryParams);
    }
    return _.pick(queryParams, supportedParams);
  }

  selectAllLocations(): void {
    this.locations.map(item => {
      return (item.checked = !this.selectAll);
    });
  }

  deleteItem(id) {
    if (confirm('Do you want to delete this location?')) {
      store.dispatch({ type: DELETE_LOCATION_REQUESTED, data: id });
    }
  }

  updateLocation(location) {
    let data = {
      id: location.getId(),
      code: location.getCode(),
      name: location.getName(),
      type: location.getType(),
      destination_id: location.destination.getId()
    };
    store.dispatch({ type: UPDATE_LOCATION_REQUESTED, data: data });
  }
}
